module.exports = "/static/assets/189b1da760b0d569e410616b4cab89d8.png";